import styled from 'styled-components';

export const NumbersInfoStyled = styled.div`
  .column-box {
    display: flex;
    flex-direction: column;
  }
  .value_t {
    position: absolute;
    right: 0;
    top: -28px;
    font-size: 22px;
    font-weight: bold;
    /* line-height: 22px; */
    /* background: linear-gradient(
      to right,
      ${(props) => {
      return props.theme[props.brand].fontColor.g0001[0];
    }},
      ${(props) => props.theme[props.brand].fontColor.g0001[1]}
    ); */
    background: #1565c0;
    -webkit-background-clip: text; /* 规定背景的划分区域 */
    background-clip: text; /* 规定背景的划分区域 */
    -webkit-text-fill-color: transparent; /* 防止字体颜色覆盖 */
  }
  .vip_count {
    font-size: 12px;
    white-space: nowrap;
  }
  .flex-box {
    display: flex;
  }
  .dormancy-member {
    .value_t {
      /* background: linear-gradient(
        to right,
        ${(props) => {
        return props.theme[props.brand].fontColor.g0002[0];
      }},
        ${(props) => props.theme[props.brand].fontColor.g0002[1]}
      ); */
      -webkit-background-clip: text; /* 规定背景的划分区域 */
      background-clip: text; /* 规定背景的划分区域 */
      -webkit-text-fill-color: transparent; /* 防止字体颜色覆盖 */
    }
  }
  .label_t {
    color: ${(props) => props.theme[props.brand].fontColor.c0001};
    margin-top: 6px;
  }
  .label_p {
    color: #757575;
    color: ${(props) => props.theme[props.brand].fontColor.c0012};
    min-width: 39px;
    width: 100%;
    display: inline-block;
    line-height: 14px;
  }
  .no_date {
    color: ${(props) => props.theme[props.brand].fontColor.c0001};
    display: flex;
    flex-direction: column;
    margin-left: 8px;
    line-height: 14px;
  }
  .no_num {
    color: ${(props) => props.theme[props.brand].fontColor.c0001};
    display: flex;
    flex-direction: column;
    /* margin: 0 8px 0 19px; */
    min-width: 64px;
    margin: 0 8px 0 16px;
    line-height: 14px;
    gap: 8px;
  }
  .no_date:first-of-type,
  .no_num:first-of-type {
    font-weight: bold;
  }
  .no_number {
    color: ${(props) => props.theme[props.brand].fontColor.c0001};
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    line-height: 14px;
    gap: 8px;
    margin-left: 8px;
    .up_number:nth-child(1) {
      font-weight: bold;
    }
  }

  .up_number {
    color: ${(props) => props.theme[props.brand].fontColor.c0004};
  }
  .down_number {
    color: ${(props) => props.theme[props.brand].fontColor.c0011};
  }
`;
